import { Text } from '@mnd-frontend/ui';

const ProductOverview = () => (
  <>
    <Text as="h3" variant="headlineSmall">
      Different parts of the product
    </Text>
    <Text as="p" variant="body" marginBottom="SPACING_2">
      Mynewsdesk consists of four parts, and your access will vary depending on your subscription.
      Let’s quickly run through them all.
    </Text>
    <Text as="h4" variant="labelMedium">
      Publish
    </Text>
    <Text as="p" variant="body" marginBottom="SPACING_2">
      This is where it all starts. It is in Publish where you create, distribute and publish your
      stories and other content like images and videos. The publication form for the three story
      types— press releases, news and blog posts—look the same to make it easy for you. Attach
      images and add related content to your stories to build connections among your content.
    </Text>
    <Text as="h4" variant="labelMedium">
      Contacts
    </Text>
    <Text as="p" variant="body" marginBottom="SPACING_2">
      Add your own contacts and see who your followers are. Create your own lists based on interests
      or geographic regions. This makes it easier to pick lists to distribute your content to. If
      you want to dig deeper into each contact, you can view exactly which content a contact has
      received and how engaged it is.
    </Text>
    <Text as="h4" variant="labelMedium">
      Monitor
    </Text>
    <Text as="p" variant="body" marginBottom="SPACING_2">
      Find out what’s being said and written about you and learn who your audience is. By setting up
      search profiles, you can monitor not only your brand or company, but also competitors, your
      industry on ongoing campaigns. It is a great way to follow up, and to be the first to know
      what's coming.
    </Text>
    <Text as="h4" variant="labelMedium">
      Analyze
    </Text>
    <Text as="p" variant="body">
      Follow up on your PR work and see actual numbers and data of who has opened, read and clicked
      on your content. In this way, you get an understanding of how successful your content is, and
      how good your relationship with your audience is. By benchmarking your PR work against other
      newsrooms in Mynewsdesk, you get helpful insights of where you need to put more focus and
      where you are already succeeding.
    </Text>
  </>
);

export default ProductOverview;
